export default class NflUtil {
  static formatNflTeamAbbr(nflTeamAbbr) {
    if (!nflTeamAbbr) return nflTeamAbbr;

    if (["LAC", "LAR", "NYG", "NYJ"].includes(nflTeamAbbr)) return nflTeamAbbr;

    switch (nflTeamAbbr) {
      case "GNB":
        return "GB";
      case "KAN":
        return "KC";
      case "LVR":
        return "LV";
      case "NWE":
        return "NE";
      case "NOR":
        return "NO";
      case "SFO":
        return "SF";
      case "TAM":
        return "TB";
      default:
        return (
          nflTeamAbbr.charAt(0).toUpperCase() +
          nflTeamAbbr.substring(1).toLowerCase()
        );
    }
  }
}
